// src/components/Home.js (Updated with FAQ)

import React from 'react';
import Hero from './Hero'; 
import HowItWorks from './HowItWorks'; 
import Categories from './Categories';
import Testimonial from './Testimonial'; 
import FAQ from './FAQ'; // <-- Import the new component
import './Home.css'; 

const Home = () => {
  return (
    <div className="home-page">
      
      {/* 1. Hero Section */}
      <Hero />
      
      {/* 2. Main Sections Wrapper */}
      <div className="home-sections-wrapper">
        <div className="main-content">
            
            {/* How It Works Section */}
            <HowItWorks /> 
            
            {/* Categories/Explore Section */}
            <Categories /> 
            
            {/* Testimonial/Social Proof Section */}
            <Testimonial /> 
            
            {/* FAQ Section (Placement adjusted to use full width and padding defined in FAQ.css) */}
            {/* Note: The Testimonial component already contains a final CTA, so we put FAQ right before the end */}
            
        </div>
        {/* FAQ is often full-width or uses its own unique background/padding */}
        <FAQ /> 

      </div>
      
    </div>
  );
};

export default Home;